import type { components } from '@pocapan/shared/types/schema';

type Episode = components['schemas']['ApiV1SceneEpisode'];

export interface PageItem {
  episode: Episode;
  pageIndex: number;
  totalPagesForEpisode: number;
  globalPageIndex: number;
}

export const flattenEpisodesToPages = (
  episodes: Episode[],
  episodePageCounts: number[]
): PageItem[] => {
  const pages: PageItem[] = [];
  let globalPageIndex = 0;

  for (let i = 0; i < episodes.length; i += 1) {
    const episode = episodes[i];
    const totalPagesForEpisode = Math.max(1, episodePageCounts[i] ?? 1);

    for (let pageIndex = 0; pageIndex < totalPagesForEpisode; pageIndex += 1) {
      pages.push({
        episode,
        pageIndex,
        totalPagesForEpisode,
        globalPageIndex
      });
      globalPageIndex += 1;
    }
  }

  return pages;
};
